 

document.addEventListener('DOMContentLoaded', () => {
  // --- 1. Sticky Header Handler ---
  const header = document.querySelector('.l-header');
  let lastScrollY = window.scrollY;

  if (header) {
    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > 50) {
        header.classList.add('is-scrolled');
        header.classList.remove('is-header-top');
      } else {
        header.classList.remove('is-scrolled');
        header.classList.add('is-header-top');
      }

      if (currentScrollY > lastScrollY && currentScrollY > 150) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }

      lastScrollY = currentScrollY;
    });

    if (window.scrollY <= 50) {
      header.classList.add('is-header-top');
    }
  }

  // --- 2. Drawer Navigation Overlay Toggle ---
  const toggler = document.querySelector('.l-header__gnav__toggler');
  const drawer = document.querySelector('.l-gnav');

  if (toggler && drawer) {
    toggler.addEventListener('click', () => {
      const isOpen = drawer.classList.contains('is-open');
      if (isOpen) {
        drawer.classList.remove('is-open');
        toggler.classList.remove('is-active');
        document.body.style.overflow = '';
      } else {
        drawer.classList.add('is-open');
        toggler.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }
    });

    const drawerLinks = drawer.querySelectorAll('a');
    drawerLinks.forEach(link => {
      link.addEventListener('click', () => {
        drawer.classList.remove('is-open');
        toggler.classList.remove('is-active');
        document.body.style.overflow = '';
      });
    });
  }

  // --- 3. Vanilla Image Slider (Learning Carousel) ---
  const slidesContainer = document.querySelector('.c-image-gallery__slides');
  const slides = document.querySelectorAll('.c-image-gallery__slide');
  const prevBtn = document.querySelector('.c-image-gallery__btn--prev');
  const nextBtn = document.querySelector('.c-image-gallery__btn--next');

  if (slidesContainer && slides.length > 0) {
    let currentIndex = 0;
    const totalSlides = slides.length;

    const goToSlide = (index) => {
      if (index < 0) {
        currentIndex = totalSlides - 1;
      } else if (index >= totalSlides) {
        currentIndex = 0;
      } else {
        currentIndex = index;
      }
      slidesContainer.style.transform = `translateX(-${currentIndex * 100}%)`;
    };

    if (prevBtn) prevBtn.addEventListener('click', () => goToSlide(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goToSlide(currentIndex + 1));

    setInterval(() => {
      goToSlide(currentIndex + 1);
    }, 5000);
  }

  // --- 4. Concept Video Modal Handler ---
  const modalOverlay = document.getElementById('video-modal');
  const modalIframe = document.getElementById('modal-iframe');
  const modalCloseBtn = document.querySelector('.modal-close');
  const movieButtons = document.querySelectorAll('[data-youtubeid]');

  movieButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const youtubeId = btn.getAttribute('data-youtubeid') || 'Job2TCCGPNc';
      if (modalIframe) {
        modalIframe.src = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`;
      }
      if (modalOverlay) {
        modalOverlay.classList.add('is-active');
      }
    });
  });

  const closeModal = () => {
    if (modalOverlay) modalOverlay.classList.remove('is-active');
    if (modalIframe) modalIframe.src = '';
  };

  if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeModal);
  if (modalOverlay) {
    modalOverlay.addEventListener('click', (e) => {
      if (e.target === modalOverlay) closeModal();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
  });


    // --- 5. Story Hero Background Switcher Handler ---
  const switcherBtns = document.querySelectorAll('.p-story-hero__switcher-btn');
  const storyHeroSection = document.querySelector('.p-story-hero');

  if (switcherBtns.length > 0 && storyHeroSection) {
    switcherBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const mode = btn.getAttribute('data-bg-mode'); // 'color', 'image', 'video'
        switcherBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        storyHeroSection.classList.remove('is-bg-color', 'is-bg-image', 'is-bg-video');
        storyHeroSection.classList.add(`is-bg-${mode}`);
      });
    });
  }
});
